module.exports = __webpack_public_path__ + "img/qy_05.png";